import { render, staticRenderFns } from "./ModalDetailReservation.vue?vue&type=template&id=31c3c094&"
import script from "./ModalDetailReservation.vue?vue&type=script&lang=js&"
export * from "./ModalDetailReservation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports